var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden"},[_c('div',{staticClass:"content text-center"},[_c('v-img',{attrs:{"src":require("../../public/logo-surf.png")}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"noselect"},[_vm._v("403")]),_c('h2',{staticClass:"noselect"},[_vm._v("Access Denied")])])
}]

export { render, staticRenderFns }